import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Welcome to Green Engineering & Environmental Solutions.
        </p>
       <p>
        Our new site is coming soon!!!
       </p>
      </header>
    </div>
  );
}

export default App;
